// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"58f6d107","835":"edfaa25d","962":"3518e971"}[chunkId] + ".chunk.js";
};